module.exports = __webpack_public_path__ + "img/valleint6.4cd8e0e5.png";